import { render, staticRenderFns } from "./factura-form.vue?vue&type=template&id=7897d1da&scoped=true"
import script from "./factura-form.vue?vue&type=script&lang=js"
export * from "./factura-form.vue?vue&type=script&lang=js"
import style0 from "./factura-form.vue?vue&type=style&index=0&id=7897d1da&prod&lang=css"
import style1 from "./factura-form.vue?vue&type=style&index=1&id=7897d1da&prod&scoped=true&lang=css"
import style2 from "./factura-form.vue?vue&type=style&index=2&id=7897d1da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7897d1da",
  null
  
)

export default component.exports